import React, { useState, useMemo, useEffect } from 'react';
import MaterialTable from 'material-table';
import { Fab, withStyles, Typography, Tooltip, IconButton } from '@material-ui/core';
import * as actions from './store/transportColliActions';
import * as action from '../../np-core/Auth/store/authActions';
import { connect } from 'react-redux';
import { Add, Refresh, Delete } from '@material-ui/icons';
import TransportColliDelete from './TransportColliDelete'
import { hasPermission, BackButton, localization, hasAtLeastOnePermission, getDimensionsOfPagination } from '../../sc-utilities';
import DataRange from '../../sc-utilities/DateRange';
import { CsvBuilder } from 'filefy';
import Toolbar from '../../sc-utilities/Toolbar';
import { MuiTableRows } from '../../../themes';
import momentTimezone from 'moment-timezone';
import moment from 'moment';

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
        "[classs*='MuiFab-extended MuiFab-sizeSmall']": {
            width: 'auto',
            height: '34px',
            padding: '0 8px',
            minWidth: '34px',
            borderRadius: '1px'
        },
    },
    fab: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        borderRadius: '1px',
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customToolbar: {
        marginLeft: 14,
        width: "900px",
        paddingTop: '4px'
    },
    tableTitle: {
        display: 'flex',
        flexDirection: 'row',
        paddingTop: '4px',
        alignItems: 'center',
        overflow: 'visible',
    },
    tableTitleRefresh: {
        marginBottom: '32px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});

let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const TransportColliList = props => {
    const { classes, translations, goToCreateTransportColli, fetching, deleting, activeExternalServiceAvailable, onBulkDeleteTransportCollies, saveColumnsFilter, fetchTransportColliDataCount, activeCustomerID, permissions, tableColumns, fetchTransportColliData, tableRef } = props;
    const [deleteModalState, setDeleteModalState] = useState({
        open: false,
        transportColliIDs: [],
    });

    const [dateRangeValue, setDateRangeValue] = useState(null);

    useEffect(() => {
        const customerTimezone = window.localStorage.getItem("CustomerTimezone") ?? 'UTC';

        const from = momentTimezone.tz(moment().subtract(1, 'years'), customerTimezone);

        const to = momentTimezone.tz(moment(), customerTimezone);
        
        setDateRangeValue({
            From: from,
            To: to,
            maxDate: to.set({
                hours: 23,
                minutes: 59,
                seconds: 59,
            })
        });
        // eslint-disable-next-line
    }, [ activeCustomerID ]);

    const customExport = (columns, transportColliesList) => {
        if (columns && columns[0].field === 'Action') {
            columns.shift()
        }
        if (!activeExternalServiceAvailable) {
            tableColumns.splice(1, 1);
        }
        const data = transportColliesList.map(transportColli => {
            let returnObj = [
                transportColli.TransportColliInventoryID ? transportColli.TransportColliInventoryID : translations['short_not_assigned'] || 'n/a',
                transportColli.PaletteExternalInfo && transportColli.PaletteExternalInfo.length > 0 ? transportColli.PaletteExternalInfo.map((externalInfo) => { return `${externalInfo.ExternalServiceType} - ${externalInfo.ExternalID}` }) : translations['short_not_assigned'] || 'n/a',
                transportColli.Order && transportColli.Order.Name ? transportColli.Order.Name : translations['short_not_assigned'] || 'n/a',
                transportColli.Description ? transportColli.Description : translations['short_not_assigned'] || 'n/a',
                transportColli.ReportInformation ? transportColli.ReportInformation : translations['short_not_assigned'] || 'n/a',
                transportColli.FilePattern && transportColli.FilePattern.Name ? transportColli.FilePattern.Name : translations['short_not_assigned'] || 'n/a',
                transportColli.ErasureReportSignature ? translations['yes'] || 'Yes' : translations['no'] || 'No',
                transportColli.Deleted ? translations['yes'] || 'Yes' : translations['no'] || 'No',
            ];
            if (!activeExternalServiceAvailable) {
                returnObj.splice(1, 1);
            }
            return returnObj;
        });
        const builder = new CsvBuilder(`securaze_transport_colli_${Math.floor(Date.now() / 1000)}.csv`);
        builder
            .setDelimeter('|')
            .setColumns(columns.map(columnDef => columnDef.title))
            .addRows(data)
            .exportFile();
    };

    const selectionPermissions = hasAtLeastOnePermission(permissions, ['transport_colli_delete']);
    const deletePermission = hasPermission(permissions, 'transport_colli_delete');

    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            selection: selectionPermissions,
            selectionProps: rowData => {
                let disabled = false;
                if (!deletePermission || (deletePermission && Array.isArray(rowData.Products) && rowData?.Products.length > 0)) {
                    disabled = true;
                }
                rowData.tableData.disabled = disabled;
                return disabled ? {
                    disabled: true,
                    checked: false
                } : {}
            },
            search: false,
            minBodyHeight: window.innerHeight - 290 < 300 ? 300 : window.innerHeight - 290,
            maxBodyHeight: window.innerHeight - 290,
            pageSizeOptions: rowsPageSizeInit,
            exportButton: false,
            exportCsv: customExport,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
            },
            columnsButton: true,
            pageSize: pageSize,
            emptyRowsWhenPaging: false
        });

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    };

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        query['ActiveCustomerID'] = activeCustomerID;
        query['q'] = q;

        query['From'] = dateRangeValue?.From.format('YYYY-MM-DD');
        query['To'] = dateRangeValue?.To.format('YYYY-MM-DD');
        
        let count = await fetchTransportColliDataCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize
        }
        let result = count ? await fetchTransportColliData(query) : [];
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };
    }

    const tableTitle = () => {
        return <div className={classes.customToolbar}>
            <div className={classes.tableTitle}>
                {BackButton(translations, classes.customTooltip)}
                <Typography className={classes.typography}>{translations["transport_collies"] || "Transport collies"}</Typography>
                {hasPermission(permissions, "transport_colli_create") ? (
                    <Fab
                        variant="extended"
                        size="small"
                        color="primary"
                        aria-label="Add"
                        className={classes.fab}
                        style={{ borderRadius: '1px' }}
                        onClick={goToCreateTransportColli}
                    >
                        <Add size="small" />
                        {translations["create_new"] || "Create new"}
                    </Fab>) : null}

            </div>
            <div className={classes.tableTitleRefresh}>
                {dateRangeValue && <DataRange
                    initialValues={dateRangeValue}
                    filterDataRange={filterDataRange}
                    value={dateRangeValue}
                    setValue={setDateRangeValue}
                    format="yyyy/MM/dd 00:00:00"
                    translations={translations}>
                </DataRange>}
                <Tooltip title={translations["refresh"] || "Refresh"}>
                    <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                        <Refresh />
                    </IconButton>
                </Tooltip>
            </div>

        </div>
    };

    const handleBulkDelete = transportColliIDS => {
        if (!transportColliIDS) {
            setDeleteModalState({ open: false, transportColliIDs: [] });
            return;
        }
        setDeleteModalState({ ...deleteModalState, open: true, transportColliIDs: transportColliIDS });
    };

    const filterDataRange = async (range) => {
        dateRangeValue.From = range.From
        dateRangeValue.To = range.To
        tableRef.current && tableRef.current.onQueryChange()
    };

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`TransportColli`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomerID })
        return newColumnState
    };

    const handleCloseSafe = () => {
        setDeleteModalState({ open: false, networkZoneIDs: [] });
    };

    const handleCloseDanger = async () => {
        await onBulkDeleteTransportCollies({ TransportColliIDs: deleteModalState.transportColliIDs, ActiveCustomerID: activeCustomerID });
        handleBulkDelete();
        tableRef.current && tableRef.current.onQueryChange()
    };

    const tableActions = [
        {
            tooltip: `${translations['remove_all_selected'] || 'Remove all selected'} ${translations["transport_collies"] || "Transport collies"}`,
            icon: <Delete />,
            hidden: !hasPermission(permissions, "transport_colli_delete"),
            onClick: (rowData) => handleBulkDelete(rowData.map(transportColli => transportColli.TransportColliID))
        }
    ];

    return (<>
        <MaterialTable
            tableRef={tableRef}
            title={tableTitle()}
            columns={columnObject}
            data={fetchTableData}
            components={{
                Toolbar: props => (
                    <Toolbar data={props} actions={tableActions} selectedRows={props.selectedRows} translations={translations} />
                )
            }}
            options={tableOptions}
            isLoading={fetching}
            localization={localization(translations)}
            onChangeRowsPerPage={(size) => {
                pageSize = size
            }}
            onChangeColumnHidden={columnHidden}
            onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
        />
        {hasPermission(permissions, "transport_colli_delete") ? (
            <TransportColliDelete
                activeCustomerID={activeCustomerID}
                entityName={translations["transport_colli"] || "Transport Colli"}
                translations={translations}
                handleCloseSafe={handleCloseSafe}
                handleCloseDanger={handleCloseDanger}
                deleteModalState={deleteModalState}
                deleting={deleting}
            />
        ) : null}
    </>)
};

const mapStateToProps = state => {
    return {
        activeExternalServiceAvailable: state.core.login.activeExternalServiceAvailable,
        permissions: state?.core?.login?.permissions || [],
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        fetching: state.palette.transportCollies.fetching,
        deleting: state.palette.transportCollies.deleting,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

const mapDispatchToProps = dispatch => {
    return {
        fetchTransportColliDataCount: filter => dispatch(actions.fetchTransportColliCount(filter)),
        fetchTransportColliData: filter => dispatch(actions.fetchTransportColli(filter)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        onBulkDeleteTransportCollies: transportColli => dispatch(actions.bulkDeleteTransportCollies(transportColli)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(TransportColliList));